import {OnboardingWizardStep} from "@/lib/types/accounts.ts";

import {StepContent} from "../step/Step";
import {StepConnectedBody} from "./StepConnectedBody";

export const STEP_CONNECTED: StepContent = {
  name: OnboardingWizardStep.CONNECTED,
  title: "Stay Connected",
  subtitle: "Receive alerts and respond on the go with the mobile app.",
  body: StepConnectedBody,
};
